import React, {useMemo} from "react";
import {useTranslation} from "gatsby-plugin-react-i18next";
import HeroScene from "./hero-scene";
import HeroCopy from "./hero-copy";
import {sklep, hotel, wsparcie, SCENE_TINTS} from "./demo-scenarios";

const Hero = () => {
    const {t, i18n} = useTranslation();

    const sceny = useMemo(() => [
        {src: "/images/mainhero/persons/person_1.webp", alt: t("Customer shopping online"), scenariusz: sklep(t), tint: SCENE_TINTS.shop},
        {src: "/images/mainhero/persons/person_3.webp", alt: t("Guests at a seaside hotel"), scenariusz: hotel(t), tint: SCENE_TINTS.hotel},
        {src: "/images/mainhero/persons/person_2.webp", alt: t("Customer service team at work"), scenariusz: wsparcie(t), tint: SCENE_TINTS.support},
    ], [t, i18n.language]);

    return (
        <div className="relative flex items-center justify-center flex-col w-full mx-auto max-w-screen-2xl px-3">
            <div className="grid-bg-hero -inset-x-[100vw]" aria-hidden="true"/>
            <div className="relative flex flex-col-reverse lg:flex-row items-center justify-between w-full gap-10 lg:gap-10">
                <div className="w-full lg:w-[52%]">
                    <HeroScene scenes={sceny} rotate height={620}/>
                </div>
                <div className="w-full lg:w-[48%]">
                    <HeroCopy
                        eyebrow={t("AI agent for customer service")}
                        eyebrowDetail={t("Chat, phone, WhatsApp, e-mail drafts")}
                        line1={t("Customers get answers now.")}
                        line2={t("Your team gets its time back.")}
                        lead={t("The agent learns from your website, documents and FAQs, answers in 80+ languages, and reaches into your systems for order status or availability. No code required.")}
                        proof={{value: "70–80%", label: t("of enquiries handled without a human, at our customers"), to: "#case-studies"}}
                    />
                </div>
            </div>
        </div>
    );
};

export default Hero;
